import { HttpClient } from '@angular/common/http';
import { Component, inject, type OnInit } from '@angular/core';
import { generateId } from '../../../server/services/utils.service';
import { AnalyticsService } from '../analytics.service';
import { TitleService } from '../title.service';

@Component({
  selector: 'app-super-admin-scripts',
  templateUrl: './super-admin-scripts.component.html',
  styleUrls: ['./super-admin-scripts.component.scss'],
  standalone: false,
})
export class SuperAdminScriptsComponent implements OnInit {
  private http = inject(HttpClient);
  private titleService = inject(TitleService);
  private analyticsService = inject(AnalyticsService);

  ngOnInit() {
    this.titleService.set('Scripts - Super admin');
  }

  googleTagRegistration() {
    this.analyticsService.register('email');
  }

  googleTagPurchase() {
    this.analyticsService.purchase({
      value: 100,
      currency: 'AUD,',
      transactionId: generateId(),
    });
  }

  superAdmin404() {
    this.http
      .post('/api/super-admin/no-script', {})
      .subscribe((result) => console.log(result));
  }
}
